<template>
  <v-card>
    <v-system-bar dark window color="accent">
      <v-icon center>mdi-account-check</v-icon>
      <v-toolbar-title class="ml-1">Список доступных признаков</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn small icon @click="$emit('close-dialog')">
        <v-icon class="mx-0">clear</v-icon>
      </v-btn>
    </v-system-bar>
    <v-card-text class="px-0">
      <v-treeview :items="objects" item-key="element_id">
        <template slot="prepend" slot-scope="{ item, open, leaf }">
          <v-icon size="20" class="mx-0">{{getIcon(item.element_type)}}</v-icon>
          <v-tooltip top v-if="item.element_type!=='post' && item.element_type!=='property'">
            <v-icon size="20" class="ml-1" slot="activator">{{item.assigned_type===0 ? 'mdi-format-list-bulleted' : 'mdi-file-tree'}}</v-icon>
            <span>{{item.assigned_type===0 ? 'Только выбранный' : 'Включая вложенные'}}</span>
          </v-tooltip>
        </template>
      </v-treeview>
    </v-card-text>
    <v-divider></v-divider>
  </v-card>
</template>

<script>
  import entities from '@/mixins/entities'
  
  export default {
    name : "AccessList",
  
    mixins: [entities],
    
    props:{
      objects:{
        type: Array,
        required: false,
        default: () => []
      }
    },
    
    created(){
      this.convertArrayobjects(this.objects, 'element_id', 'element_type')
      let properties = [], folders = []
      this.objects.map( el => {
        if(el.element_type === 'property') properties.push(el.element_id)
        else if(el.element_type === 'folder') folders.push(el.element_id)
        else if(el.element_type === 'all_props') el.name = 'Признаки'
      })
      if(properties.length>0 || folders.length>0){
        this.$store.dispatch('analytics/constructor/propertiesData', {properties_ids: properties, folders_ids: folders}).then(response => {
          response.properties.map(item => {
            let index = this.objects.findIndex( el => (el.element_id===item.id.toString() && el.element_type==='property'))
            if(index>-1) this.objects[index].name = item.identified
          })
          response.folders.map(item => {
            let index = this.objects.findIndex( el => (el.element_id===item.id.toString() && el.element_type==='folder'))
            if(index>-1) this.objects[index].name = item.identified
          })
        })
      }
    },
    
    methods:{
      getIcon(type){
        switch(type){
          case 'post':
            return 'mdi-account'
            break
          case 'container':
            return 'mdi-account-group'
            break
          case 'property':
            return 'mdi-rhombus-medium'
            break
          case 'folder':
          case 'all_props':
            return 'mdi-folder'
            break
        }
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/analytics/components/Constructor/Forms/AccessList.vue